import React from "react";
import "./Gallery.css";

// Import Images
import img2 from "../../assets/Image/NewImages/CarrierRoadMap.jpeg";
import img1 from "../../assets/Image/NewImages/A.jpeg";
import img3 from "../../assets/Image/NewImages/p_img5.jpeg";
import img4 from "../../assets/Image/NewImages/InteractiveCarrier.jpeg";
import img5 from "../../assets/Image/NewImages/PersonalGuidance.jpeg";
import img6 from "../../assets/Image/NewImages/p_img4.jpeg";
import img7 from "../../assets/Image/NewImages/Sam_banner3.jpg";
import img8 from "../../assets/Image/NewImages/Sam_banner4.jpg";
import img9 from "../../assets/Image/NewImages/Sam_Banner2.jpeg";

function Gallery() {
  return (
    <div className="gallery-section">
      <h2 className="gallery-title">Our Gallery</h2>

      <div className="gallery-grid">
        <div className="gallery-item">
          <img src={img1} loading="lazy" decoding="async" alt="Gallery 1" />
        </div>

        <div className="gallery-item">
          <img src={img2} loading="lazy" decoding="async" alt="Gallery 2" />
        </div>

        <div className="gallery-item">
          <img src={img3} loading="lazy" decoding="async" alt="Gallery 3" />
        </div>

        <div className="gallery-item">
          <img src={img4} loading="lazy" decoding="async" alt="Gallery 4" />
        </div>

        <div className="gallery-item">
          <img src={img5} loading="lazy" decoding="async" alt="Gallery 5" />
        </div>

        <div className="gallery-item">
          <img src={img6} loading="lazy" decoding="async" alt="Gallery 6" />
        </div>
        <div className="gallery-item">
          <img src={img7} alt="Gallery 6" />
        </div>
        <div className="gallery-item">
          <img src={img8} loading="lazy" decoding="async" alt="Gallery 6" />
        </div>
        <div className="gallery-item">
          <img src={img9} loading="lazy" decoding="async" alt="Gallery 6" />
        </div>
      </div>
    </div>
  );
}

export default Gallery;
